module.exports = __webpack_public_path__ + "img/team.26f7b23c.svg";